export { default as I18nProvider } from './Provider'
export { LOCALES }  from './Locales'